import { Injectable } from '@angular/core';
import { SaleOrder } from '../../objects/sale-order';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class SaleOrderService extends DatabaseGwService {
  URL_PATH: string = "/sale-orders";

  reCalcSaleOrder(saleOrder:SaleOrder):SaleOrder{
    let newSaleOrder:SaleOrder = saleOrder;

    //calculate total
    let discountAmt = newSaleOrder.discount_rate * newSaleOrder.sub_total;
    newSaleOrder.order_total = newSaleOrder.sub_total - discountAmt;

    return newSaleOrder;
}
}
